import React, { useEffect, useRef } from 'react'
import TextDecoration from '../../utility/TextDecoration';
import { Ratings } from '../reviews/Ratings';
import VizSensor from 'react-visibility-sensor';
import styles from './card.module.css'
import { useViewport } from '../../utility/useViewport';

export const VideoVCard = (props) => {
    const listing = props.listing;
    const thumb = listing.thumbnailImage ? listing.thumbnailImage : 'assets/Desert.jpg'
    const isMobile = useViewport()

    let isViewCounted = false;
    const timeOut = useRef(null);
    /**const runTimer = (infocus) => {
        if (!isViewCounted && infocus)
            timeOut.current = setTimeout(() => countView(), 5000);
        else if (!infocus && timeOut.current)
            clearTimeout(timeOut.current)
    }**/
    const handleClick = () => {
        !isViewCounted && countView();
        props.showContent(listing, props.section)
    }
    const countView = () => {
        timeOut.current && clearTimeout(timeOut.current)
        isViewCounted = true;
        //listingService.updateSingleListingViews(props.section, listing);
    }
    useEffect(() => {
        return () => timeOut.current && clearTimeout(timeOut.current)
    }, [timeOut])

    return (
        <VizSensor
        /**onChange={(isVisible) => {
            runTimer(isVisible)
        }}**/
        >
            {listing.listingType === 'article' ?
                <div className="col-12 col-sm-6 col-lg-4 col-xl-3 col-xxl-2 low_padding ">
                    <div className={styles.listing_card_video} onClick={handleClick}>
                        <div className={styles.listing_thumb_image_video}>
                            <img className="img-fluid" loading='lazy' src={process.env.REACT_APP_IMAGES_URL + thumb} alt={listing.businessName} />
                            <div className={styles.play_icon_overlay}>
                                <div className={styles.play_icon_circle}>
                                    <i className="fas fa-play"></i>
                                </div>
                            </div>
                        </div>
                        <div className="listing_details">
                            <h6 className={isMobile ? styles.mob_listing_title_video : styles.listing_title_video}>{TextDecoration.ellipsize(listing.businessName, 65)}</h6>
                            <div className="listing_address">
                                <div className={styles.listing_info_box_desc_newsArt_video}> {TextDecoration.ellipsize(listing.specializedIn, 130)}</div>
                                <div className={styles.basicVideoSubCat}>
                                    <span className={`${styles.name_span}`}>By:</span> {TextDecoration.ellipsize(listing.subCategories, 45)}
                                </div>
                            </div>
                            <div className="listing_address">
                                {(props.isViewed) ? <i className="fas fa-check-circle viewed_mark"></i> : null}
                            </div>
                        </div>
                    </div>
                </div> : listing.listingType === 'clips' ?
                    <div className="col-6 col-sm-4 col-md-3 col-lg-2 low_padding">
                        <div className="clip_card" onClick={handleClick}>
                            <div>
                                <img className="img-fluid" loading='lazy' src={process.env.REACT_APP_IMAGES_URL + thumb} alt={listing.businessName} />
                                <div className={styles.play_icon_overlay}>
                                    <div className={styles.play_icon_circle}>
                                        <i className="fas fa-play"></i>
                                    </div>
                                </div>
                            </div>
                            <div className="clip_description text-left">
                                <div className="description">
                                    <h6 className={isMobile ? styles.mob_listing_title_video : styles.clip_title_video}>{TextDecoration.ellipsize(listing.businessName, 50)}</h6>
                                    <div className={styles.basicVideoSubCatClip} style={{ color: '#fff' }}>
                                        <span className={`${styles.name_span}`}>By:</span> {TextDecoration.ellipsize(listing.subCategories, 45)}
                                    </div>
                                </div>
                            </div>
                            {(props.isViewed) ? <i className="fas fa-check-circle viewed_mark"></i> : null}
                        </div>
                    </div> : null}
        </VizSensor>
    )
}